import React, { useRef, useState, useEffect } from 'react';

interface TextAreaProps {
    name: string;
    id: string;
    desc: string;
    required?: boolean;
}

const Textarea: React.FC<TextAreaProps> = ({ name, id, desc, required = false }) => {
    const [width, setWidth] = useState<number>(0);
    const textRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (textRef.current) {
            setWidth(textRef.current.getBoundingClientRect().width);
        }
    }, []);

    return (
        <label htmlFor={id} className="block text-sm w-full relative">
            <div className="absolute left-0 top-2" ref={textRef}>
                {desc}
            </div>
            
            <textarea
                name={name}
                id={id}
                className="resize-none block w-full border-b-2 min-h-24 font-semibold border-black/10 outline-none p-2 transition-all duration-200 focus:border-black"
                required={required}
                style={{ paddingLeft: width + 8 }} 
            ></textarea>
        </label>
    );
};

export default Textarea;
